module.exports = __webpack_public_path__ + "img/gwrraSeal@1x.1cd5eb95.webp";